import type { CalibrationKind, PartType, ServiceRecord } from '../../types';

type UnitFormatter = (params: { number: number }) => string;

type GetServiceRecordTargetParams = {
    calibrationKindLabels: Record<CalibrationKind, string>;
    emDash: string;
    partLabels: Record<PartType, string>;
    record: ServiceRecord;
    unitFormatters: Partial<Record<PartType, UnitFormatter>>;
};

// What the record targeted, for the summary line: a calibration kind, a specific
// unit ("Motor 2"), a part label, or an em dash for whole-aircraft inspections.
export const getServiceRecordTarget = ({
    calibrationKindLabels,
    emDash,
    partLabels,
    record,
    unitFormatters
}: GetServiceRecordTargetParams): string => {
    if (record.eventType === 'calibrated') {
        return calibrationKindLabels[record.calibrationKind];
    }

    if (!record.partType) {
        return emDash;
    }

    const formatUnit = unitFormatters[record.partType];

    if (record.unitNumber !== undefined && formatUnit) {
        return formatUnit({ number: record.unitNumber });
    }

    return partLabels[record.partType];
};
